import type { RTBPrice } from '@creator/sdk/modules/token-price/token-price.model';
import creatorSdk from '@src/services/creator-sdk';

export async function loadRTBPrice(): Promise<RTBPrice> {
    return creatorSdk.tokenPriceModule.getRTBPrice();
}
